
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categorias]/[...news]",
      function () {
        return require("private-next-pages/[categorias]/[...news].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categorias]/[...news]"])
      });
    }
  